import React from 'react';
import styled from 'styled-components';

function Dialog({title, description, buttons, ...props}) {
  return (
    <Container {...props}>
      <h4>{title}</h4>
      <p style ={{whiteSpace: 'pre-line'}}>{description}</p>
      <Buttons>{buttons}</Buttons>
    </Container>
  );
}

const Container = styled.div`
  width: 25rem;

  h4 {
    margin: 0;
    font-size: 1.125rem;
  }

  p {
    margin: 1rem 0 1.125rem 0;
    line-height: 1.5;
  }
`;

const Buttons = styled.div`
  button {
    min-width: 6rem;
    margin-right: 1rem;
  }
`;

export default Dialog;